module.exports = __webpack_public_path__ + "static/overview-bf2abcc1c84c93604d53d1d30545d2b4.png";